import { gql } from '__generated__';

export default gql(`
  mutation ConfirmLotteryResult($input: ConfirmLotteryResultInput!) {
    confirmLotteryResult(input: $input) {
      status
      redirect_url
    }
  }
`);
